import React, { useState, useEffect, FC, useMemo, useRef } from 'react';
import './forecast-boxes-table.scss';
import ForecastBoxesTableRow from '../forecast-boxes-table-row/forecast-boxes-table-row';
import { useSelector } from 'react-redux';
const ForecastBoxesTable = (props) => {
    const ic_products = useSelector((state: any) => state.product.ic_products);

    const setChecked = (checked: boolean, name: string, boxSize: string) => {
        console.log({checked}, {name}, {boxSize})
        const config = props.selectedBoxes[name]
        if(!checked)
            return;
        if(boxSize === 'three_liter') {
            config.five_liter = false
            config.seven_liter = false
        } else if(boxSize === 'five_liter') {
            config.three_liter = false
            config.seven_liter = false
        } else if(boxSize === 'seven_liter') {
            config.three_liter = false
            config.five_liter = false
        }
        config[boxSize] = checked
        props.setSelectedBoxes(prev => ({...prev, [name]: config}))
    }
    
    return (
        <div className="forecast-boxes-table">
            <div className="forecast-boxes-table__table">
                <div className="forecast-boxes-table__table__header">
                    <div>Product</div>
                    <div>7L</div>
                    <div>5L</div>
                    <div>3L</div>
                </div>
                <div className="forecast-boxes-table__table__body">
                    {ic_products.map((stock) => {
                        const cfg = props.selectedBoxes[stock.name]
                        return <ForecastBoxesTableRow key={stock.id} id={stock.id} name={stock.name} three_liter={cfg?.three_liter} five_liter={cfg?.five_liter} seven_liter={cfg?.seven_liter} setChecked={(checked, id, boxSize)=>setChecked(checked, stock.name, boxSize)}/>
                    })}
                </div>
            </div>
        </div>
    );
}
         
export default ForecastBoxesTable;